import React from 'react';
import logo from '~/utils/images/logo.svg';
import classes from './MaintenancePage.module.css';

const MaintenancePage = () => (
  <div className={classes.container}>
    <img src={logo} alt='Cobu' className={classes.logo} />
    <h1 className={classes.title}>Cobu is down for maintenance. We'll be back shortly.</h1>
    <p className={classes.subtitle}>Thanks for your patience.</p>
  </div>
);

export default MaintenancePage;
